export default class TerminationModal {
  init() {
    if (document.URL.includes('trax/notebooks')) {
      this.initRequiredFieldsValidation();
      this.initModalSigning();
    }
  }

  initRequiredFieldsValidation() {
    const requiredError = $('#required-error');
    requiredError.hide();
    $('#termination-save-button').on('click', function () {
      const reasonsLost = $('input[name="notebook[reasons_lost]"]').val();
      const termedDate = $('input[name="notebook[date_lost]"]').val();
      if (reasonsLost === '' || termedDate === '') {
        requiredError.show();
      } else {
        $('#offboardingModal').find('form').submit();
      }
    });
  }

  initModalSigning() {
    const signingField = $('#name-input');
    const saveButton = $('#termination-save-button');
    signingField.on('input', function () {
      const currentPersonName = $('#current-person-name').text();
      saveButton.prop('disabled', $(this).val() !== currentPersonName);
    });
  }
}
